module.exports = __webpack_public_path__ + "img/personality-1.f07f3027.svg";